import React, { forwardRef } from 'react';

export const SpaceInput = forwardRef(({ label, type = 'text', options = [], children, className='', ...props }, ref) => {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && <label className="text-xs font-medium text-gray-500">{label}</label>}
      {type === 'select' ? (
        <select 
          ref={ref}
          className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-gray-900 bg-white"
          {...props}
        >
          {children ? children : options.map((opt, i) => <option key={i} value={opt.value || opt}>{opt.label || opt}</option>)}
        </select>
      ) : (
        <input 
          ref={ref}
          type={type} 
          className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-gray-900"
          {...props} 
        />
      )}
    </div>
  );
});




